export default "__VITE_ASSET__ed48c33e__"